<template>
    <v-row align="center" justify="center">
        <v-card class="elevation-12">
        <v-card-title> <h3>New User Registration Form</h3></v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Login"
                name="email"
                v-model="email"
                prepend-icon="person"
                type="text"
              />
              <v-text-field
                id="password"
                label="Password"
                name="password"
                v-model="password"
                prepend-icon="lock"
              />
              <v-checkbox
                v-model="isAdmin"
                label="Admin"
              ></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="register()">Register</v-btn>
          </v-card-actions>
        </v-card>
        <v-snackbar
      v-model="snackbar"
      color="accent"
      :timeout=5000
      :top="true"
    >
      {{ errorMessage }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Chiudi
      </v-btn>
    </v-snackbar>
    </v-row>
</template>
<style scoped="true">
h3{
  width:100%;
  margin-bottom: 1rem;
}
</style>
<script>
import api from '@/api'

export default {
  name: "UserRegister",
  data: () => ({
    errorMessage: '',
    snackbar: false,
    isAdmin: false,
    email: '',
    password: ''
  }),
  methods: {
    async register () {
      try{
        const response = await api.register({
          email: this.email,
          password: this.password,
          isAdmin: this.isAdmin
        })
        console.log(response) 
      } catch (error){
        this.errorMessage = error.data
        this.snackbar = true
      }
    }
  }
};
</script>
